module.exports = __webpack_public_path__ + "img/Sent.8e50a288.svg";